import React, { useEffect, useState } from "react";
import { Star } from "lucide-react";
import api from "../lib/api";
import { useLang, catLabel } from "../lib/i18n";

export function ReviewsBadge() {
  const { t, lang } = useLang();
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/reviews/summary").then((r) => setData(r.data)).catch(() => setData(null));
  }, []);

  if (!data || !data.count) return null;
  const rounded = Math.round(data.average);

  return (
    <div data-testid="reviews-badge" className="mt-3 rounded-2xl border border-amber-200 bg-gradient-to-br from-amber-50 to-white p-4">
      <div className="flex items-center gap-3">
        <div className="text-center">
          <p className="font-display text-3xl font-extrabold leading-none text-slate-900" data-testid="reviews-average">{data.average.toFixed(1)}</p>
          <div className="mt-1 flex gap-0.5">
            {[1, 2, 3, 4, 5].map((s) => (
              <Star key={s} className={`h-3.5 w-3.5 ${s <= rounded ? "fill-amber-400 text-amber-400" : "text-slate-300"}`} />
            ))}
          </div>
        </div>
        <div className="h-10 w-px bg-amber-200" />
        <div>
          <p className="text-sm font-bold text-slate-900">{t("customer_reviews")}</p>
          <p className="text-xs text-slate-500" data-testid="reviews-count">{data.count} {t("reviews")}</p>
        </div>
      </div>

      {data.reviews?.length > 0 && (
        <div className="mt-3 flex gap-2 overflow-x-auto no-scrollbar">
          {data.reviews.map((r, i) => (
            <div key={i} data-testid={`review-card-${i}`} className="min-w-[200px] max-w-[220px] shrink-0 rounded-xl border border-slate-200 bg-white p-3">
              <div className="flex gap-0.5">
                {[1, 2, 3, 4, 5].map((s) => (
                  <Star key={s} className={`h-3 w-3 ${s <= r.stars ? "fill-amber-400 text-amber-400" : "text-slate-200"}`} />
                ))}
              </div>
              <p className="mt-1.5 line-clamp-3 text-xs text-slate-600">"{r.comment}"</p>
              <p className="mt-1.5 text-[11px] font-semibold text-slate-800">{r.name} <span className="font-normal text-slate-400">· {catLabel(r.category, lang)}</span></p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
